import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
import { templateConfig, reduxTemplateCofig } from './config'
let { WizBrowserExport } = component_tool

class InterviewQuestion extends WizContainer {

    componentName = 'InterviewQuestion'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _handleFile(nextProps, nextState, key) {
        let { code, data, msg } = nextProps[key]
        if (code === 1) {
            let columns = [{
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
                }
            }, {
                headerName: '岗位',
                field: 'positionNames',
                width: 40,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '品牌',
                field: 'orgNames',
                width: 40,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }, {
                headerName: '试题导入时间',
                field: 'importTime',
                width: 40,
                cellStyle: { textAlign: 'left' },
                style: { alignment: { vertical: 'middle', horizontal: 'center' } }
            }]

            WizBrowserExport({
                title: '性格自测试题',
                sheetName: '性格自测试题',
                columns: columns.filter((_, index) => index),
                rows: data || [],
                filename: '性格自测试题.xlsx',
            })
            return true
        } else {
            wizNotice.error(msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {
                export: this._handleFile
            }
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(InterviewQuestion)
